// src/lib/moneyInput.js — ONE reading of a money amount an agent typed (review 2026-09-23).
//
// Three boxes read the same keystrokes three ways: the deal-close panel turned every comma into
// a decimal point ("120,000" → 120), the cooperation box ran parseFloat ("150 000" → 150), and
// the valuation box replaced one comma ("1,500,000" → NaN → null). Each was recorded silently.
//
// The office types BOTH conventions: "550,50" is fifty tetri (audit 2026-09-07), "120,000" and
// "150 000" are thousands. The separator alone cannot tell them apart; its position can:
//   - spaces / apostrophes are always grouping;
//   - with both ',' and '.', the LAST one is the decimal point, the others group;
//   - one kind used more than once ("1,500,000") groups;
//   - used once: followed by EXACTLY three digits it groups ("120,000"), otherwise it is the
//     decimal point ("550,50", "12.5"). No amount here carries three decimal places.
// Returns a finite non-negative number, or null for empty / unreadable input (never NaN).

export function sanitizeMoneyInput(v) {
  // What a money box may HOLD while typing: digits and separators. Converting a separator here
  // would destroy the information parseMoneyInput needs, which is exactly the original bug.
  return String(v ?? '').replace(/[^\d.,\s']/g, '')
}

export function parseMoneyInput(v) {
  if (v == null) return null
  if (typeof v === 'number') return Number.isFinite(v) && v >= 0 ? v : null
  let s = String(v).trim().replace(/[\s' ]/g, '')
  if (!s || !/^[\d.,]+$/.test(s) || !/\d/.test(s)) return null
  const hasComma = s.includes(','), hasDot = s.includes('.')
  if (hasComma && hasDot) {
    const dec = s.lastIndexOf(',') > s.lastIndexOf('.') ? ',' : '.'
    const grp = dec === ',' ? '.' : ','
    s = s.split(grp).join('').replace(dec, '.')
  } else if (hasComma || hasDot) {
    const sep = hasComma ? ',' : '.'
    const parts = s.split(sep)
    if (parts.length > 2) s = parts.join('')
    else s = parts[1].length === 3 && parts[0] !== '' && parts[0] !== '0' ? parts.join('') : parts[0] + '.' + parts[1]
  }
  const n = Number(s)
  return Number.isFinite(n) && n >= 0 ? n : null
}
